module.exports = __webpack_public_path__ + "img/ringsets@2x.7b9448a.webp";